<template>
  <div class="sex__item">
    <ul class="sex__header">
      <li class="sex__title">
        {{title}}
      </li>
      <li class="sex__tools">
        <el-button type="text" class="sex__tools-button" :disabled="saveChart" @click="onSave('sex')">
          <i class="material-icons color_grey">save</i>
        </el-button>
        <el-button type="text" class="sex__tools-button" v-if="!isEdit" @click="editChart(name)">
          <i class="material-icons color_grey">edit</i>
        </el-button>
      </li>
    </ul>

    <el-card shadow="hover" class="sex__card" v-loading="pending">
      <sex-header :chart-name="name" />
      <sex-body
        :data="data"
        :chart-name="name"
        :save-chart="saveChart"
        :title="title"
        @onSavedChart="handleSaved"
        @onSaveChart="handleSave"
      />
    </el-card>
  </div>
</template>

<script>
  //actions
  import { GET_SEX, SET_AUDIT_PENDING } from "../../../../../../../store/actions/audit";

  // components
  import SexHeader from "./header/SexHeader";
  import SexBody from "./body/SexBody";

  export default {
    name: "Sex",
    data() {
      return {
        name: "Sex",
        title: this.$t('feed.audit.sex.title'),
        saveChart: false
      };
    },
    methods: {
      editChart() {
        this.$router.push({
          name: 'feedAuditEdit',
          params: {
            chart: "Sex"
          }
        });
      },
      onSave() {
        this.saveChart = true;
      },
      handleSaved(chart) {
        this.$store.commit(SET_AUDIT_PENDING, {chart, pending: false});
        this.saveChart = false;
      },
      handleSave(chart) {
        this.$store.commit(SET_AUDIT_PENDING, {chart, pending: true});
      }
    },
    computed: {
      isEdit() {
        return this.$route.meta.singlePage;
      },
      data() {
        return this.$store.getters.auditData(this.name);
      },
      pending() {
        return this.$store.getters.auditPending(this.name);
      },
    },
    mounted() {
      const params = {
        chart: this.name,
        thread: this.$route.params.threadId
      };

      this.$store.dispatch(GET_SEX, params);
    },
    components: {
      SexHeader,
      SexBody
    }
  }
</script>


<style>

  .sex__item {
    flex-basis: 50%;
    margin-right: 20px;
  }

  .sex__item:last-child {
    margin-right: 0;
  }

  .sex__card {
    margin-bottom: 20px;
  }


  .sex__header {
    display: flex;
    justify-content: space-between;
    align-items: start;
    padding: 0;
    margin: 0;
    list-style: none;
  }

  .sex__title {
    margin-bottom: 20px;
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;

    color: #5E6D82;
  }

  .sex__tools .material-icons {
    font-size: 16px;
  }

  .sex__tools {
    margin-top: 4px;
    margin-right: 15px;
  }

  .sex__tools-button {
    padding: 0;
    color: #5e6d82;
  }

  .sex__tools-button:hover {
    color: #B3BCCC;
    font-size: 12px;
  }
</style>

